import { Form, Formik } from 'formik';
import React from 'react';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { HeadContent, Skeleton } from '@fourthwall/components';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { AccountNotifications } from './components/AccountNotifications/AccountNotifications';
import { MarketingEmails } from './components/MarketingEmails/MarketingEmails';
import { Memberships } from './components/Memberships/Memberships';
import { useEmailNotifications } from './hooks/useEmailNotifications';
export const EmailNotifications = () => {
    const { handleSubmit, initialValues } = useEmailNotifications();
    if (!initialValues) {
        return (React.createElement("div", null,
            React.createElement(HeadContent, { title: "Email notifications \u2013 Account settings" }),
            React.createElement(Skeleton, { gap: 16 },
                React.createElement(Skeleton.Shape, { height: 45, width: "80%" }),
                React.createElement(Skeleton.Shape, { height: 45, width: "80%" }),
                React.createElement(Skeleton.Shape, { height: 45, width: "80%" }))));
    }
    return (React.createElement("div", null,
        React.createElement(HeadContent, { title: "Email notifications \u2013 Account settings" }),
        React.createElement(Formik, { initialValues: initialValues, enableReinitialize: true, onSubmit: handleSubmit }, ({ dirty, isValid, isSubmitting, submitForm, resetForm }) => (React.createElement(Form, null,
            React.createElement(MarketingEmails, null),
            React.createElement(AccountNotifications, null),
            React.createElement(Memberships, null),
            React.createElement(ConfirmBar, { isOpen: dirty, isLoading: isSubmitting, onConfirm: submitForm, onCancel: resetForm }),
            React.createElement(LeavingGuard, { when: dirty, isValid: isValid, onSave: submitForm }))))));
};
